import { render, staticRenderFns } from "./articlePreview.vue?vue&type=template&id=5bd7c906&scoped=true&"
import script from "./articlePreview.vue?vue&type=script&lang=js&"
export * from "./articlePreview.vue?vue&type=script&lang=js&"
import style0 from "./articlePreview.vue?vue&type=style&index=0&id=5bd7c906&scoped=true&lang=less&"
import style1 from "./articlePreview.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd7c906",
  null
  
)

component.options.__file = "articlePreview.vue"
export default component.exports